<app-dashboard *ngIf="isCandidate === false && hasUserPermission"></app-dashboard>
<app-tile-menu *ngIf="isCandidate === true || !hasUserPermission"></app-tile-menu>